import React from 'react';
import { Sparkles, Award, Truck } from 'lucide-react';
import { Link } from 'react-router-dom';

const items = [
  { Icon: Sparkles, title: 'Quality Ingredients', body: 'Every device is sourced from authorized RandM Fumot factories. Lab-grade e-liquid, mesh coil tech, sealed authenticity.' },
  { Icon: Award, title: 'Lasting Results', body: 'Up to 20,000 puffs of consistent flavor. USB-C rechargeable, adjustable airflow, vibrant LED display.' },
  { Icon: Truck, title: 'Fast Shipping', body: 'Discreet packaging, tracked dispatch, EU-friendly fulfillment. Pay in iDEAL or Card — we settle in crypto.' },
];

const Features3 = () => {
  return (
    <section className="bg-black py-20 border-t border-zinc-900">
      <div className="max-w-[1480px] mx-auto px-6 grid md:grid-cols-3 gap-10">
        {items.map(({ Icon, title, body }) => (
          <div key={title} className="text-center px-4">
            <div className="mx-auto mb-6 w-16 h-16 rounded-full border border-[#d4af37] flex items-center justify-center">
              <Icon className="h-7 w-7 text-[#d4af37]" />
            </div>
            <h3 className="serif-italic gold-gradient-text text-3xl mb-3">{title}</h3>
            <p className="text-zinc-400 leading-relaxed max-w-sm mx-auto">{body}</p>
            <Link to="/shop" className="inline-block mt-4 text-[#d4af37] border-b border-[#d4af37] pb-1 text-sm hover:text-[#f5c518]">Explore</Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features3;
